
import React from 'react';

const ValuePropositionBackground = () => {
  // Removed animate-pulse for performance
  return (
    <div className="absolute inset-0">
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-orange-500/15 to-yellow-500/15 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-500/15 to-fuchsia-500/15 rounded-full blur-3xl" />
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-gradient-to-r from-lime-500/10 to-green-500/10 rounded-full blur-3xl" />
    </div>
  );
};

export default ValuePropositionBackground;
